var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "app-header navbar"
  }, [_c('vue-progress-bar'), _vm._v(" "), _c('button', {
    staticClass: "navbar-toggler mobile-sidebar-toggler d-lg-none",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.mobileSidebarToggle
    }
  }, [_vm._v("☰")]), _vm._v(" "), _c('b-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "#"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "navbar-toggler sidebar-toggler d-md-down-none mr-auto",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.sidebarMinimize
    }
  }, [_vm._v("☰")]), _vm._v(" "), _c('div', {
    staticClass: "d-none d-lg-block",
    staticStyle: {}
  }, [_c('b', [_vm._v("KANTOR PELAYANAN UTAMA BEA DAN CUKAI TIPE B BATAM")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('font', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("TELEPON (0778) 458818, 458263; FAKSIMILI (0778) 458149;SURAT ELEKTRONIK kpubcbatam@kemenkeu.go.id")])], 1), _vm._v(" "), _c('b-nav', {
    staticClass: "ml-auto",
    attrs: {
      "is-nav-bar": ""
    }
  }, [_c('b-nav-item-dropdown', {
    attrs: {
      "right": ""
    }
  }, [_c('template', {
    slot: "button-content"
  }, [_c('span', {
    staticClass: "d-md-down-none"
  }, [_vm._v(_vm._s(_vm.user['username']))])]), _vm._v(" "), _c('b-dropdown-header', {
    staticClass: "text-center",
    attrs: {
      "tag": "div"
    }
  }, [_c('strong', [_vm._v("Account")])]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": _vm.profile
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" Profile\n      ")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": _vm.changepw
    }
  }, [_c('i', {
    staticClass: "fa fa-shield"
  }), _vm._v(" Change Password\n      ")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" Logout\n      ")])], 2), _vm._v(" "), _c('button', {
    staticClass: "navbar-toggler aside-menu-toggler d-md-down-none",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.asideToggle
    }
  }, [_vm._v("☰")])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41fef88e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 140
// module chunks = 0